export enum MomentLanguageCode {
  ZhCn = 'zh_cn',
}
